export default __webpack_public_path__ + "static/media/mastercard_logo.d98fbeb1.webp";